import { IDanhSachLopTinChiSelectRequest } from "../../../model/request/lop-tin-chi/IDanhSachLopTinChiSelectRequest";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IDanhSachLopTinChiViewModel } from "../../../model/respone/lop-tin-chi/IDanhSachLopTinChiViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface IDanhSachLopTinChiExportRequest {
  ky_dang_ky: number;
  id_lops: number[];
  id_tts: number[];
  id_doi_tuongs: number[];
  hoc_ky: number;
  nam_hoc: string;
  ten_dot: string;
  /** Tính chất học đang lọc (mã hoc_lai, chọn nhiều). Có giá trị → tổng tín chỉ/tiền chỉ tính học phần khớp. */
  tinh_chat_hocs?: number[];
}

export const eDanhSachLopTinChiiActionsObj = {
  LOAD_CHUA_TONG_HOP_TC_START: {} as IDanhSachLopTinChiSelectRequest,
  LOAD_CHUA_TONG_HOP_TC_SUCCESS: {} as IPagingResult<
    IDanhSachLopTinChiViewModel[]
  >,
  LOAD_CHUA_TONG_HOP_TC_ERRR: "",
  CHANGE_REQUEST_CHUA_TONG_HOP_TC: {} as IDanhSachLopTinChiSelectRequest,

  EXPORT_START: {} as IDanhSachLopTinChiExportRequest,
  EXPORT_SUCCESS: {} as string,
  EXPORT_ERRR: "",
};
export const eDanhSachLopTinChiiActionIds = generateActionTypeIds(
  eDanhSachLopTinChiiActionsObj,
  "DANH_SACH_LOP_TIN_CHI",
);
export type IDanhSachLopTinChiiActionTypes = IGenericActionType<
  typeof eDanhSachLopTinChiiActionsObj,
  "DANH_SACH_LOP_TIN_CHI"
>;
